import * as React from 'react';
import { InfoBarMessageSource, InfoBarMessageRank, } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import infoBarStrings from 'owa-strings/owa-common-strings';
import strings from 'owa-strings/owa-mail-strings';
export default function getDetailErrorInfobarHandler(message) {
    return function () {
        return {
            key: 'errorMessageErrorWithDetail',
            source: InfoBarMessageSource.Compose,
            rank: InfoBarMessageRank.Error,
            messageParts: [
                infoBarStrings.errorMessageMessageCanNotBeSent,
                {
                    showDetailsText: strings.moreDetailsNotificationLabel,
                    hideDetailsText: null,
                    detailsElement: React.createElement("span", null, message),
                },
            ],
        };
    };
}
//# sourceMappingURL=getDetailErrorInfobarHandler.js.map